import {Component, NgModule, Input} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule } from '@angular/common';


@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss']
})
export class Header {
  @Input() showMenu : Boolean;

  scrollToElement(el): void {
    var element = document.getElementById(el);

    if(element)
    {
      console.log(element);
      element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
    else {
      window.location.href = '/#'+el;
    }
  }

}

@NgModule({
  imports: [ MatIconModule, MatButtonModule, MatToolbarModule,CommonModule ],
  exports: [Header],
  declarations: [Header],
})
export class HeaderModule {}